import { render } from "./B2bTableMailServer.vue?vue&type=template&id=6bd6de55&scoped=true&lang=pug"
import script from "./B2bTableMailServer.vue?vue&type=script&lang=js"
export * from "./B2bTableMailServer.vue?vue&type=script&lang=js"

import "./B2bTableMailServer.vue?vue&type=style&index=0&id=6bd6de55&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd6de55"]])

export default __exports__